export default {
    name: "toggle-height",
    init() {

        const btns = document.querySelectorAll(".toggle-height");

        if(btns){
            btns.forEach((el) => {
                el.addEventListener("click", this.toggleHeight);
            });
        }
    },

    toggleHeight(event)
    {
        if (typeof this.dataset.target === 'string') {
            const el = document.getElementById(this.dataset.target).classList.toggle('active');
        }
    }


};